import { memo } from 'react';
import TrainingDataSplit, { TrainingDataSplitData } from './TrainingDataSplit';
import ModelConfiguration, { ModelParameters } from './ModelConfiguration';

interface TrainingConfigurationProps {
    datasetCount: number;
    databaseFilesCount: number;
    inputFilesLength: number;
    outputFilesLength: number;
    modelConfiguration: ModelParameters;
    isUploading: boolean;
    isGeneratingDatasets: boolean;
    isTrainingModels: boolean;
    onModelConfigChange: (config: ModelParameters) => void;
    onTrainingSplitChange: (split: TrainingDataSplitData) => void;
    sessionId?: string;
}

const TrainingConfiguration = memo(({
    datasetCount,
    databaseFilesCount,
    inputFilesLength,
    outputFilesLength,
    modelConfiguration,
    isUploading,
    isGeneratingDatasets,
    isTrainingModels,
    onModelConfigChange,
    onTrainingSplitChange,
    sessionId
}: TrainingConfigurationProps) => {
    const totalDataPoints = datasetCount || databaseFilesCount || (inputFilesLength + outputFilesLength) || 0;
    const isDisabled = isUploading || isGeneratingDatasets || isTrainingModels;

    return (
        <div className="space-y-6">
            <TrainingDataSplit
                totalDataPoints={totalDataPoints}
                datasetCount={datasetCount}
                onSplitChange={onTrainingSplitChange}
                disabled={isDisabled}
                sessionId={sessionId}
            />

            <ModelConfiguration
                value={modelConfiguration}
                onChange={onModelConfigChange}
                disabled={isDisabled}
            />
        </div>
    );
});

TrainingConfiguration.displayName = 'TrainingConfiguration';

export default TrainingConfiguration;
